import type { Context } from 'react';
import { createContext } from 'react';

type BannerContextValue = {
	includeTopNav: boolean;
};

export const BannerContext: Context<BannerContextValue> = createContext<BannerContextValue>({
	includeTopNav: true,
});

BannerContext.displayName = 'BannerContext';
